import React from 'react';
import { FaExternalLinkAlt, FaGithub } from 'react-icons/fa';

const EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
const T = `transform 0.4s ${EASE}, box-shadow 0.4s ${EASE}`;

const demoStyle = {
  display: 'inline-flex', alignItems: 'center', gap: '6px',
  fontSize: '0.82rem', fontWeight: 600, textDecoration: 'none',
  padding: '10px 22px', borderRadius: '100px', cursor: 'pointer',
  background: 'var(--accent)', color: '#FFFFFF',
  transform: 'translateY(0)',
  transition: `${T}, background 0.3s ease`,
};

const codeStyle = {
  display: 'inline-flex', alignItems: 'center', gap: '6px',
  fontSize: '0.82rem', fontWeight: 600, textDecoration: 'none',
  padding: '10px 22px', borderRadius: '100px', cursor: 'pointer',
  background: 'rgba(255, 255, 255, 0.12)',
  border: '1px solid rgba(255, 255, 255, 0.3)',
  color: '#FFFFFF',
  transform: 'translateY(0)',
  transition: `${T}, background 0.3s ease, border-color 0.3s ease`,
};

const onDemoIn = (e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(var(--accent-rgb),0.3)'; e.currentTarget.style.background = 'var(--accent-hover)'; };
const onDemoOut = (e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.background = 'var(--accent)'; };
const onCodeIn = (e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.15)'; e.currentTarget.style.background = 'rgba(255,255,255,0.25)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.5)'; };
const onCodeOut = (e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.background = 'rgba(255,255,255,0.12)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)'; };

const Projects = () => {
  const projectList = [
    {
      title: "Tu Sueldo Real",
      image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?q=80&w=1470&auto=format&fit=crop",
      text: "Calculadora de poder adquisitivo frente a la inflación en Argentina. Visualiza la pérdida o ganancia en términos reales.",
      technologies: ["React", "Tailwind v4", "Framer Motion", "Recharts"],
      demoUrl: "https://lnkd.in/dz4K9tkK",
      codeUrl: "https://lnkd.in/dTAQ5u-f",
    },
    {
      title: "Lumina Academy",
      image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?q=80&w=1374&auto=format&fit=crop",
      text: "LMS avanzado con Next.js 15. Gestión integral de aprendizaje con roles y seguimiento de progreso.",
      technologies: ["Next.js 15", "TypeScript", "Prisma", "PostgreSQL", "Tailwind"],
      demoUrl: "https://lumina-academy-six.vercel.app/",
      codeUrl: "https://github.com/AndressCoronel/lumina-academy",
    },
    {
      title: "Horizon Finance",
      image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=1470&auto=format&fit=crop",
      text: "Plataforma SaaS Fintech. Dashboard interactivo con gráficos dinámicos.",
      technologies: ["Next.js", "Appwrite", "Chart.js", "TailwindCSS"],
      demoUrl: "https://horizon-finance-zeta.vercel.app/",
      codeUrl: "https://github.com/AndressCoronel/Horizon-Finance",
    },
    {
      title: "Sistema de Reservas",
      image: "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?q=80&w=1468&auto=format&fit=crop",
      text: "Solución completa para gestión de citas con landing page y sistema administrativo.",
      technologies: ["Laravel", "PHP", "MySQL", "Bootstrap", "JS"],
      demoUrl: "https://sistema-de-reservas-q7y5.vercel.app/",
      codeUrl: "https://github.com/AndressCoronel/Sistema-de-Reservas",
    }
  ];

  return (
    <section id="projects" className="projects-section">
      <div style={{ padding: '0 40px' }}>
        <div className="text-center mb-5 reveal">
          <div className="section-label" style={{ justifyContent: 'center' }}>Portafolio</div>
          <h2 style={{ fontSize: 'clamp(2.4rem, 5vw, 3.5rem)', fontWeight: 800, letterSpacing: '-0.04em', marginBottom: '1.25rem' }}>
            Proyectos <span className="text-gradient">Destacados</span>
          </h2>
          <p style={{ color: 'var(--text-secondary)', maxWidth: '520px', margin: '0 auto', fontSize: '1.1rem', lineHeight: 1.7 }}>
            Cada proyecto es una oportunidad de innovar y superar expectativas.
          </p>
        </div>

        <div className="projects-row">
          {projectList.map((project, idx) => (
            <div key={idx} className="project-card glass-card reveal">
              <img src={project.image} alt={project.title} className="project-card-image" loading="lazy" />
              <div className="project-card-content">
                <span className="bento-number">Proyecto 0{idx + 1}</span>
                <h3 className="bento-title">{project.title}</h3>
                <p className="bento-desc">{project.text}</p>
                <div className="bento-tags">
                  {project.technologies.map((tech, tIdx) => (
                    <span className="bento-tag" key={tIdx}>{tech}</span>
                  ))}
                </div>
                <div className="bento-links">
                  <a href={project.demoUrl} target="_blank" rel="noreferrer"
                    style={demoStyle} onMouseEnter={onDemoIn} onMouseLeave={onDemoOut}>
                    <FaExternalLinkAlt size={12} /> Demo
                  </a>
                  <a href={project.codeUrl} target="_blank" rel="noreferrer"
                    style={codeStyle} onMouseEnter={onCodeIn} onMouseLeave={onCodeOut}>
                    <FaGithub size={14} /> Código
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
